import { NoticeItem } from './NoticeItem';
import type { Notice } from './types';
import styles from './NoticeStack.module.css';

interface NoticeStackProps {
  notices: Notice[];
  onDismiss: (id: number) => void;
}

/** Стопка окон справа сверху; порядок в `notices` — от новых к старым. */
export function NoticeStack({ notices, onDismiss }: NoticeStackProps) {
  if (notices.length === 0) return null;
  return (
    <div className={styles.stack}>
      {notices.map((notice) => (
        <NoticeItem key={notice.id} notice={notice} onDismiss={onDismiss} />
      ))}
    </div>
  );
}
